export default __webpack_public_path__ + "static/media/people.43430499.jpg";